<lx-form-field-selector
  [small]="small"
  [label]="label"
  [value]="value"
  valueExpr="code"
  [disabled]="disabled"
  [required]="required"
  [itemList]="regions | lxSortBy : [{ property: 'weight' }]"
  [buttonView]="false"
  [placeholder]="placeholder"
  [iconValidation]="iconValidation"
  (valueChange)="dirty = true; valueChange.emit($event)"
  (dropdownClosed)="dropdownClosed.emit()"
></lx-form-field-selector>
